import { createContext } from 'react';

import { AnnotationsTooltipConfig } from '../../core/components/annotations/components/tooltip/types/annotations-tooltip-props.js';
import type { AnnotationsActionsHandler } from '../../core/components/annotations/types/annotations.js';
import { XYChartAnnotationsProps } from '../slots/Annotations/Annotations.js';
import { XYChartAnnotationsMarkerProps } from '../slots/Annotations/Marker.js';
import { XYChartAnnotationsTrackProps } from '../slots/Annotations/Track.js';

/**
 * Configuration for XY chart annotations.
 * @public
 */
export interface XYChartAnnotationsConfigProps extends XYChartAnnotationsProps {
  /** Whether to show annotation labels. */
  showLabels: boolean;
  /** Number of fixed annotation tracks to display. */
  fixedTracks: number;
  /** Configuration for annotation tracks. */
  tracksConfig: XYChartAnnotationsTrackProps;
  /** Configuration for annotation markers. */
  markersConfig: XYChartAnnotationsMarkerProps;
  /** Configuration for the annotations tooltip. */
  tooltip: AnnotationsTooltipConfig;
  /**
   * Custom annotations actions on entry selection.
   */
  annotationsActions?: AnnotationsActionsHandler;
}

export const XYChartAnnotationsConfig = createContext<
  XYChartAnnotationsConfigProps | undefined
>(undefined);
